import { getOfferDisplayContent } from "../../../../javascript/offer-display-api";

interface props {
  publication_id: string;
  publication_title: string;
  issue_id: string;
}

const init = async (props: props) => {
  if (props.publication_id && props.issue_id && props.publication_title) {
    const element = document.querySelector('.issue-hero-rendering-space');
    const loggedInWithSubscriptionTranslationKey = 'lokalise.catalog.issue_hero.read_this_issue_text';
    const offerTextUnderButtonTranslationKey = 'lokalise.catalog.offer_condition_text';
    const response = await getOfferDisplayContent(
      props.publication_id,
      props.issue_id,
      props.publication_title,
      loggedInWithSubscriptionTranslationKey,
      offerTextUnderButtonTranslationKey,
    );
    element.innerHTML = response.body;
  } else {
    throw new Error('IssueHero: prop missing');
  }
}

export const IssueHero = {
  init,
};
